import { z } from "zod";

export const LoginRequestSchema = z.object({
  identifier: z.string().min(1),
  password: z.string().min(1),
});
export type LoginRequest = z.infer<typeof LoginRequestSchema>;

export const LoginResponseSchema = z.object({
  identifier: z.string(),
  displayName: z.string(),
});
export type LoginResponse = z.infer<typeof LoginResponseSchema>;

export const MeResponseSchema = LoginResponseSchema;
export type MeResponse = z.infer<typeof MeResponseSchema>;
